module.exports = __webpack_public_path__ + "img/404.18a4d252.svg";